<template>
  <button
    type="button"
    class="ui-grid__insert-button"
    aria-label="Insert row"
    :style="{ top: `${top}px` }"
    @mousedown.prevent
  >
    <PlusIcon class="w-4 h-4" />
  </button>
</template>

<script setup lang="ts">
import { PlusIcon } from '@heroicons/vue/24/outline'

type Props = {
  top?: number
}

const { top } = defineProps<Props>()
</script>

<style scoped>
.ui-grid__insert-button {
  @apply absolute z-[999] left-1 -translate-y-1/2;
  @apply w-5 h-5 flex items-center justify-center;
  @apply rounded-full border border-common-border;
  @apply bg-body text-indigo-400 dark:text-indigo-300;
  @apply text-sm font-semibold leading-none;
}
</style>
